// src/components/common/FlowerDecor.jsx
import React, { useId, memo } from 'react';

const FlowerDecor = () => {
  const uid = useId();
  const g1 = `g1-${uid}`;
  const g2 = `g2-${uid}`;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-0" aria-hidden="true">
      
      <svg
        className="absolute -top-10 -left-10 w-56 opacity-20"
        viewBox="0 0 200 200"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={g1} x1="0" x2="1">
            <stop offset="0" stopColor="#FCE7F3" />
            <stop offset="1" stopColor="#E11D79" />
          </linearGradient>
        </defs>
        <g fill={`url(#${g1})`}>
          <circle cx="40" cy="40" r="40" />
          <path d="M100 20c10 20 40 20 50 0-10 20-40 20-50 0z" />
        </g>
      </svg>

      <svg
        className="absolute -bottom-16 -right-16 w-72 opacity-20"
        viewBox="0 0 300 200"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={g2} x1="0" x2="1">
            <stop offset="0" stopColor="#F59ACB" />
            <stop offset="1" stopColor="#B0125A" />
          </linearGradient>
        </defs>
        <g fill={`url(#${g2})`}>
          <ellipse cx="150" cy="100" rx="120" ry="60" />
          <circle cx="200" cy="40" r="22" />
        </g>
      </svg>
    </div>
  );
};

export default memo(FlowerDecor);
